import React from 'react';
import RichtextParser from '../../../utils/richtext-parser';
import Section404 from '../../section-404';

function Storyblok404Adapter({ title, paragraph }) {
  return <Section404 title={title} paragraph={RichtextParser(paragraph)} />;
}

export default Storyblok404Adapter;
